export const USERSTORE_SECURITY_GROUP = -1
export const METADATA_SECURITY_GROUP = 1
export const CONTENT_SECURITY_GROUP = 2
export const APPLICATION_SECURITY_GROUP = 3
export const VIEW_SECURITY_GROUP = 4